module.exports = __webpack_public_path__ + "img/sponsor.fa421a33.png";